package com.anjuros.website.redesign.util

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.px

/** All line icons used by the redesigned pages. They draw in currentColor. */
object RdIcons {

    @Composable
    fun Phone(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(7, 2.5, 10, 19, 2.5) })
            Path(attrs = { attr("d", "M11 18.5h2") })
        }
    }

    @Composable
    fun Search(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Circle(attrs = { circle(10.5, 10.5, 6.5) })
            Path(attrs = { attr("d", "M15.5 15.5 21 21") })
        }
    }

    @Composable
    fun Globe(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Circle(attrs = { circle(12, 12, 9) })
            Path(attrs = { attr("d", "M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3") })
        }
    }

    @Composable
    fun Lock(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(4.5, 10.5, 15, 10.5, 2) })
            Path(attrs = { attr("d", "M8 10.5V7.5a4 4 0 0 1 8 0v3") })
        }
    }

    @Composable
    fun Mail(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(3, 5, 18, 14, 2) })
            Path(attrs = { attr("d", "m3.5 6 8.5 7 8.5-7") })
        }
    }

    @Composable
    fun Copy(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(8.5, 8.5, 12, 12, 2) })
            Path(attrs = { attr("d", "M15.5 5.5v-.5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h.5") })
        }
    }

    @Composable
    fun Dashboard(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(3, 4, 18, 16, 2.5) })
            Path(attrs = { attr("d", "M3 9h18M8 13h4M8 16h7") })
        }
    }

    @Composable
    fun Pencil(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M4 20l4-1 11-11-3-3L5 16zM14 7l3 3") })
        }
    }

    @Composable
    fun Code(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "m8 7-5 5 5 5M16 7l5 5-5 5M13.5 4l-3 16") })
        }
    }

    @Composable
    fun Clock(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Circle(attrs = { circle(12, 12, 9) })
            Path(attrs = { attr("d", "M12 7v5l3 2") })
        }
    }

    @Composable
    fun Star(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "m12 3 2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.4 6.7 19.4l1.2-6L3.4 9.3l6-.7z") })
        }
    }

    @Composable
    fun GraduationCap(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M3 9.5 12 5l9 4.5-9 4.5zM7 11.5V16c3 2 7 2 10 0v-4.5") })
        }
    }

    @Composable
    fun Chat(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M4 5h16v11H9l-5 4z") })
        }
    }

    @Composable
    fun Briefcase(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Rect(attrs = { rect(3, 7, 18, 13, 2) })
            Path(attrs = { attr("d", "M8 7V5h8v2") })
        }
    }

    @Composable
    fun ShieldCheck(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M12 3 4.5 6v6c0 4.4 3.2 7.7 7.5 9 4.3-1.3 7.5-4.6 7.5-9V6zM9 12l2 2 4-4") })
        }
    }

    @Composable
    fun Bolt(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M13 3 5 13h6l-1 8 8-10h-6z") })
        }
    }

    @Composable
    fun Check(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 2.4) }) {
            Path(attrs = { attr("d", "M5.5 12.5l4 4 9-10") })
        }
    }

    @Composable
    fun Car(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M5 16v-5l2-5h10l2 5v5M3 16h18v2H3z") })
            Circle(attrs = { circle(7.5, 13, 0.8) })
            Circle(attrs = { circle(16.5, 13, 0.8) })
        }
    }

    @Composable
    fun Pound(modifier: Modifier = Modifier, size: Int = 24) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon() }) {
            Path(attrs = { attr("d", "M15.5 7.5A3.5 3.5 0 0 0 9 9.5V18h8M7 13h6") })
        }
    }

    @Composable
    fun Menu(modifier: Modifier = Modifier, size: Int = 18) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 2) }) {
            Path(attrs = { attr("d", "M4 7h16M4 12h16M4 17h16") })
        }
    }

    @Composable
    fun Close(modifier: Modifier = Modifier, size: Int = 18) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 2) }) {
            Path(attrs = { attr("d", "M6 6l12 12M18 6 6 18") })
        }
    }

    @Composable
    fun ChevronLeft(modifier: Modifier = Modifier, size: Int = 20) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 2) }) {
            Path(attrs = { attr("d", "M15 18l-6-6 6-6") })
        }
    }

    @Composable
    fun Info(modifier: Modifier = Modifier, size: Int = 20) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 1.8) }) {
            Circle(attrs = { circle(12, 12, 9) })
            Path(attrs = { attr("d", "M12 11v5M12 7.5v.01") })
        }
    }

    /** A filled-in page: the template shown with example content. */
    @Composable
    fun ExampleContent(modifier: Modifier = Modifier, size: Int = 18) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 1.8) }) {
            Path(attrs = { attr("d", "M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9zM14 3v6h6M8 13h8M8 17h5") })
        }
    }

    /** An empty dashed box: the template shown with placeholders for the customer's details. */
    @Composable
    fun YourDetails(modifier: Modifier = Modifier, size: Int = 18) {
        Svg(attrs = modifier.size(size.px).toAttrs { lineIcon(strokeWidth = 1.8) }) {
            Rect(attrs = { rect(3, 3, 18, 18, 2); attr("stroke-dasharray", "3 3") })
            Path(attrs = { attr("d", "M8 12h8") })
        }
    }
}

private fun AttrsScope<*>.lineIcon(strokeWidth: Number = 1.7) {
    attr("viewBox", "0 0 24 24")
    attr("fill", "none")
    attr("stroke", "currentColor")
    attr("stroke-width", strokeWidth.toString())
    attr("stroke-linecap", "round")
    attr("stroke-linejoin", "round")
    attr("aria-hidden", "true")
}

private fun AttrsScope<*>.circle(cx: Number, cy: Number, r: Number) {
    attr("cx", cx.toString())
    attr("cy", cy.toString())
    attr("r", r.toString())
}

private fun AttrsScope<*>.rect(x: Number, y: Number, width: Number, height: Number, rx: Number) {
    attr("x", x.toString())
    attr("y", y.toString())
    attr("width", width.toString())
    attr("height", height.toString())
    attr("rx", rx.toString())
}
